module.exports = __webpack_public_path__ + "static/media/acerta-logo-new.7f592849.png";